"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Medication = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Medication_web_style_1 = require("./Medication.web.style");
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
const atome_1 = require("../../../atome");
const organisms_1 = require("../../../organisms");
const User_service_1 = __importDefault(require("../../../../services/User.service"));
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const enums_1 = require("../../../../enums");
const InputLoader_1 = __importDefault(require("../../../atome/InputLoader/InputLoader"));
// @ts-ignore
function Medication({ navigation }) {
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [takeOtherMedicines, setTakeOtherMedicines] = (0, react_1.useState)();
    const [otherMedicines, setOtherMedicines] = (0, react_1.useState)('');
    const [takeOtherMedicinesOtherDiseases, setTakeOtherMedicinesOtherDiseases] = (0, react_1.useState)();
    const [otherMedicinesOtherDiseases, setOtherMedicinesOtherDiseases] = (0, react_1.useState)('');
    const [effectiveness, setEffectiveness] = (0, react_1.useState)(0);
    const [saveSuccess, setSaveSuccess] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [isSaving, setSaving] = (0, react_1.useState)(false);
    // VALIDATION
    const [error, setError] = (0, react_1.useState)({
        otherMedicines: false,
        otherMedicinesOtherDiseases: false,
    });
    const validate = () => {
        const newError = {
            otherMedicines: takeOtherMedicines === undefined ||
                (takeOtherMedicines && otherMedicines.length === 0),
            otherMedicinesOtherDiseases: takeOtherMedicinesOtherDiseases === undefined ||
                (takeOtherMedicinesOtherDiseases &&
                    otherMedicinesOtherDiseases.length === 0),
        };
        setError(newError);
        return newError;
    };
    const save = async () => {
        const newError = validate();
        if (Object.values(newError).find(e => e)) {
            return;
        }
        const medicationalEfficacy = userInformation?.therapy?.medicationalEfficacy;
        const data = {
            therapy: {
                takeOtherMedicines: takeOtherMedicines,
                otherMedicines: otherMedicines,
                takeOtherMedicinesOtherDiseases: takeOtherMedicinesOtherDiseases,
                otherMedicinesOtherDiseases: otherMedicinesOtherDiseases,
                medicationalEfficacy: [
                    {
                        id: medicationalEfficacy && medicationalEfficacy.length > 0
                            ? medicationalEfficacy[0].id
                            : undefined,
                        effectiveness: effectiveness === 0 ? 11 : effectiveness,
                    },
                ],
            },
        };
        setSaving(true);
        const response = await User_service_1.default.update(data);
        setSaving(false);
        if (response.error) {
            console.log(response.message);
        }
        if (!response.error) {
            const newUserInformation = { ...userInformation };
            newUserInformation.therapy = {
                ...userInformation?.therapy,
                ...data.therapy,
            };
            dispatch((0, reducers_1.setUserInformation)(newUserInformation));
            setSaveSuccess(true);
            setTimeout(() => {
                setSaveSuccess(false);
                navigation.navigate('CaseHistoryOverview');
            }, 2000);
        }
    };
    const getUserInformation = async () => {
        const information = userInformation;
        (0, reducers_1.setUserInformation)(information);
        if (information.therapy?.takeOtherMedicines !== undefined) {
            setTakeOtherMedicines(information.therapy.takeOtherMedicines);
        }
        if (information.therapy?.otherMedicines !== undefined) {
            setOtherMedicines(information.therapy.otherMedicines);
        }
        if (information.therapy?.takeOtherMedicinesOtherDiseases !== undefined) {
            setTakeOtherMedicinesOtherDiseases(information.therapy.takeOtherMedicinesOtherDiseases);
        }
        if (information.therapy?.otherMedicinesOtherDiseases) {
            setOtherMedicinesOtherDiseases(information.therapy.otherMedicinesOtherDiseases);
        }
        if (information.therapy?.medicationalEfficacy &&
            information.therapy?.medicationalEfficacy.length > 0) {
            setEffectiveness(Number(information.therapy.medicationalEfficacy[0].effectiveness) === 11
                ? 0
                : Number(information.therapy.medicationalEfficacy[0].effectiveness));
        }
        setLoading(false);
    };
    (0, react_1.useEffect)(() => {
        return navigation.addListener('focus', async () => {
            setLoading(true);
            if (userInformation.id) {
                await getUserInformation();
            }
        });
    }, []);
    (0, react_1.useEffect)(() => {
        getUserInformation().then(() => { });
    }, [userInformation]);
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
        react_1.default.createElement(react_native_1.SafeAreaView, null,
            react_1.default.createElement(react_native_1.ScrollView, null,
                react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
                react_1.default.createElement(react_native_1.View, { style: Medication_web_style_1.styles.container },
                    react_1.default.createElement(react_native_1.View, { style: GlobalStyles_1.globalStyles.marginBottom40 },
                        react_1.default.createElement(react_native_1.Text, { style: Medication_web_style_1.styles.heading2 }, "Medikation"),
                        react_1.default.createElement(atome_1.Label, null, "Bevor Sie einen Termin zur Erstvorstellung vereinbaren k\u00F6nnen, ben\u00F6tigen wir noch weitere Angaben"),
                        react_1.default.createElement(atome_1.Label, null, "zu ihrer bisherigen Medikation.")),
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.marginRow] },
                            react_1.default.createElement(atome_1.Label, null, "Nehmen Sie aktuell Medikamente wegen Ihrer Haupterkrankung?"),
                            react_1.default.createElement(react_native_1.View, { style: GlobalStyles_1.globalStyles.flex1 },
                                react_1.default.createElement(atome_1.RadioButton, { isSelected: takeOtherMedicines !== undefined && takeOtherMedicines, label: "Ja", disabled: userInformation?.progress.isDataConfirm, onPress: () => setTakeOtherMedicines(true) }),
                                takeOtherMedicines && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(atome_1.Label, { style: [
                                            GlobalStyles_1.globalStyles.flex0,
                                            GlobalStyles_1.globalStyles.marginBottom10,
                                        ] }, "Welche Medikamente nehmen Sie wegen Ihrer Haupterkrankung?"),
                                    react_1.default.createElement(atome_1.Label, { style: [
                                            GlobalStyles_1.globalStyles.flex0,
                                            GlobalStyles_1.globalStyles.marginBottom5,
                                        ] }, "Bitte f\u00FCllen Sie das Feld nach folgendem Schema aus:"),
                                    react_1.default.createElement(atome_1.Label, { style: [
                                            GlobalStyles_1.globalStyles.flex0,
                                            GlobalStyles_1.globalStyles.marginBottom5,
                                        ] }, "Name Medikament, Dosierung (mg/ml/etc.), Zeitpunkt & Menge, Begonnen am"),
                                    react_1.default.createElement(atome_1.Label, { style: [
                                            GlobalStyles_1.globalStyles.flex0,
                                            GlobalStyles_1.globalStyles.marginBottom10,
                                        ] },
                                        "zum Beispiel:",
                                        '\n',
                                        "Ortoton Recordati, 750mg Filmtablette, abends 2 Tabletten, 1.10.2020"),
                                    react_1.default.createElement(atome_1.TextArea, { onChange: setOtherMedicines, value: otherMedicines, isEditable: !userInformation?.progress.isDataConfirm &&
                                            takeOtherMedicines, style: [
                                            Breakpoints_1.isDesktop && GlobalStyles_1.globalStyles.marginRight0,
                                            GlobalStyles_1.globalStyles.marginBottom35,
                                        ] }))),
                                takeOtherMedicines && error.otherMedicines && (react_1.default.createElement(react_native_1.Text, { style: [Medication_web_style_1.styles.errorEmptyField] }, enums_1.ErrorMessages.EMPTY_FIELD)),
                                react_1.default.createElement(atome_1.RadioButton, { isSelected: !takeOtherMedicines && takeOtherMedicines !== undefined, label: "Nein", disabled: userInformation?.progress.isDataConfirm, onPress: () => setTakeOtherMedicines(false) }))),
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.marginRow] },
                            react_1.default.createElement(atome_1.Label, null, "Nehmen Sie aktuell weitere Medikamente wegen anderer Erkrankungen?"),
                            react_1.default.createElement(react_native_1.View, { style: GlobalStyles_1.globalStyles.flex1 },
                                react_1.default.createElement(atome_1.RadioButton, { isSelected: takeOtherMedicinesOtherDiseases !== undefined &&
                                        takeOtherMedicinesOtherDiseases, label: "Ja", disabled: userInformation?.progress.isDataConfirm, onPress: () => setTakeOtherMedicinesOtherDiseases(true) }),
                                takeOtherMedicinesOtherDiseases && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(atome_1.Label, { style: [
                                            GlobalStyles_1.globalStyles.flex0,
                                            GlobalStyles_1.globalStyles.marginBottom10,
                                        ] }, "Welche weiteren Medikamente nehmen Sie?"),
                                    react_1.default.createElement(atome_1.Label, { style: [
                                            GlobalStyles_1.globalStyles.flex0,
                                            GlobalStyles_1.globalStyles.marginBottom5,
                                        ] }, "Bitte f\u00FCllen Sie das Feld nach folgendem Schema aus:"),
                                    react_1.default.createElement(atome_1.Label, { style: [
                                            GlobalStyles_1.globalStyles.flex0,
                                            GlobalStyles_1.globalStyles.marginBottom5,
                                        ] }, "Name Medikament, Dosierung (mg/ml/etc.), Zeitpunkt & Menge, Begonnen am"),
                                    react_1.default.createElement(atome_1.Label, { style: [
                                            GlobalStyles_1.globalStyles.flex0,
                                            GlobalStyles_1.globalStyles.marginBottom10,
                                        ] },
                                        "zum Beispiel:",
                                        '\n',
                                        "Ortoton Recordati, 750mg Filmtablette, abends 2 Tabletten, 1.10.2020"),
                                    react_1.default.createElement(atome_1.TextArea, { onChange: setOtherMedicinesOtherDiseases, value: otherMedicinesOtherDiseases, isEditable: !userInformation?.progress.isDataConfirm &&
                                            takeOtherMedicinesOtherDiseases, style: [
                                            Breakpoints_1.isDesktop && GlobalStyles_1.globalStyles.marginRight0,
                                            GlobalStyles_1.globalStyles.marginBottom35,
                                        ] }))),
                                takeOtherMedicinesOtherDiseases &&
                                    error.otherMedicinesOtherDiseases && (react_1.default.createElement(react_native_1.Text, { style: [Medication_web_style_1.styles.errorEmptyField] }, enums_1.ErrorMessages.EMPTY_FIELD)),
                                react_1.default.createElement(atome_1.RadioButton, { isSelected: !takeOtherMedicinesOtherDiseases &&
                                        takeOtherMedicinesOtherDiseases !== undefined, label: "Nein", disabled: userInformation?.progress.isDataConfirm, onPress: () => setTakeOtherMedicinesOtherDiseases(false) }))),
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.marginRow] },
                            react_1.default.createElement(atome_1.Label, null,
                                "Wie wirksam sind Ihre derzeitigen Medikamente? ",
                                '\n',
                                " (0 = keine Wirkung bis 10 = sehr gute Wirkung)"),
                            react_1.default.createElement(atome_1.Slider, { style: [Medication_web_style_1.styles.slider], value: effectiveness, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setEffectiveness(value) })),
                        saveSuccess && (react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, Medication_web_style_1.styles.saveMessageContainer] },
                            react_1.default.createElement(react_native_1.Text, { style: [Medication_web_style_1.styles.saveMessageText] }, "Speichern erfolgreich"))),
                        !userInformation?.progress.isDataConfirm && (react_1.default.createElement(react_native_1.View, { style: [
                                GlobalStyles_1.globalStyles.row,
                                GlobalStyles_1.globalStyles.marginRow,
                                Medication_web_style_1.styles.buttonContainer,
                            ] },
                            react_1.default.createElement(react_native_1.Pressable, { pointerEvents: isSaving ? 'none' : 'auto', style: [
                                    isSaving ? Medication_web_style_1.styles.buttonLoading : Medication_web_style_1.styles.button,
                                    GlobalStyles_1.globalStyles.saveButtonContainer,
                                ], onPress: save },
                                isSaving ? react_1.default.createElement(InputLoader_1.default, null) : null,
                                react_1.default.createElement(react_native_1.Text, { style: Medication_web_style_1.styles.buttonText }, "Speichern")),
                            Object.values(error).find(e => e) && (react_1.default.createElement(react_native_1.Text, { style: [Medication_web_style_1.styles.errorText] }, enums_1.ErrorMessages.ERROR)))),
                        react_1.default.createElement(react_native_1.View, { style: [
                                GlobalStyles_1.globalStyles.row,
                                GlobalStyles_1.globalStyles.marginRow,
                                Medication_web_style_1.styles.buttonContainer,
                            ] },
                            react_1.default.createElement(react_native_1.Pressable, { onPress: () => navigation.navigate('CaseHistoryOverview') },
                                react_1.default.createElement(react_native_1.Text, { style: Medication_web_style_1.styles.backButtonText }, "\u2190 Zur\u00FCck")))))))));
}
exports.Medication = Medication;
